import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../../utils/genIdempotencyKey";
import { goalBasedFinancialPlanKeyMaker } from "../../plan/hooks/useGetGoalBasedFinancialPlan";
import postGoalBasedFinancialPlanIncome from "../requests/postGoalBasedFinancialPlanIncome";
const IDEMPOTENCY_DESCRIPTOR = "post-goal-based-financial-plan-income";
const usePostGoalBasedFinancialPlanIncome = (config) => {
    const queryClient = useQueryClient();
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const mutation = useMutation({
        mutationFn: async ({ goalBasedFinancialPlanId, body }) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return postGoalBasedFinancialPlanIncome(goalBasedFinancialPlanId, body, idempotencyKey, config);
        },
        onSuccess: ({ goalBasedFinancialPlanId, }) => {
            queryClient.invalidateQueries({
                queryKey: goalBasedFinancialPlanKeyMaker(goalBasedFinancialPlanId),
            });
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default usePostGoalBasedFinancialPlanIncome;
//# sourceMappingURL=usePostGoalBasedFinancialPlanIncome.js.map